import React from 'react';
import UploadImage from 'components/UploadImage';
import CloseIcon from 'assets/icons/close.svg';
import { LogoUploaderProps } from 'interfaces/components/logoUploader';

const LogoUploader = ({
  title,
  companyLogoURL,
  onImageUpload,
  handleImageUploadInputClick,
  setCompanyLogoURL,
  fileInputRef,
  invalidFileSize = false
}: LogoUploaderProps) => {
  return (
    <div className='w-full flex flex-col gap-2'>
      <p className='text-base font-light'>{title}</p>
      <div className='w-full flex gap-3'>
        <UploadImage
          onClick={handleImageUploadInputClick}
          companyLogoURL={companyLogoURL}
          onImageUpload={onImageUpload}
          ref={fileInputRef}
        />

        <div>
          <div className='flex items-center gap-2 mb-2'>
            {companyLogoURL && (
              <img
                src={CloseIcon}
                alt='Close Icon'
                className='cursor-pointer'
                onClick={() => {
                  setCompanyLogoURL(null);
                }}
              />
            )}
            <div
              className='inline-block cursor-pointer  font-light text-base px-4 py-[6.5px] rounded-[200px] border border-gray-400'
              onClick={handleImageUploadInputClick}
            >
              Upload
            </div>
          </div>

          <div>
            <p className='font-light text-sm mr-2'>
              JPEG or PNG only. 1MB limit.
            </p>

            <p className='font-light text-xs mr-2 text-gray-700'>
              Ideal aspect ratios are 1:1, 3:4, or 4:3
            </p>

            {invalidFileSize && (
              <p className='text-xs font-light text-red-500'>
                (File size exceeds 1MB)
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoUploader;
